import { trpc } from '@org/clients/school';
import type { Gender, UserType } from '@org/model';
import { useAuth } from '../components/login/auth-context';

/**
 * Cohort/gender info for the logged-in user.
 *
 * Reuses the same `users.getUserByEmail` query as `LocaleProvider` and
 * `useFeatureFlags`, so it adds no extra network requests. While the profile
 * is loading, `type`/`gender` are undefined — callers that hide UI for b2b
 * should treat "unknown" as "don't render yet" rather than flashing content.
 */
export const useUserType = () => {
  const { user } = useAuth();
  const email = user?.email ?? '';
  const { data: profile, isLoading } =
    trpc.users.getUserByEmail.useQuery(email, { enabled: Boolean(email) });

  const type = profile?.type as UserType | undefined;
  const gender = (profile?.gender as Gender | undefined) ?? 'female';

  return { type, gender, isB2b: type === 'b2b', isLoading };
};
